export const MomentTimeFormat = {
    TwentyFourHourNoLeading: 'H:mm',
    TwentyFourHourWithLeading: 'HH:mm',
    TwelveHourWithLeading: 'hh:mm',
    TwelveHourNoLeading: 'h:mm',
    AnteTwentyFourHour: 'H:mm A',
    AnteTwelveHour: 'h:mm A',
};
